export default __webpack_public_path__ + "static/media/icon-linkedin.354d3d90.svg";